class KoketaSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-slider-track]');
    this.slides = [...this.querySelectorAll('[data-slider-slide]')];
    this.toggleButton = this.querySelector('[data-slider-toggle]');
    this.delay = Number(this.dataset.delay || 5000);
    this.index = 0;
    this.userPaused = false;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.querySelector('[data-slider-prev]')?.addEventListener('click', () => this.goTo(this.index - 1));
    this.querySelector('[data-slider-next]')?.addEventListener('click', () => this.goTo(this.index + 1));
    this.toggleButton?.addEventListener('click', () => this.toggleAutoplay());
    this.addEventListener('pointerenter', () => this.pause());
    this.addEventListener('pointerleave', () => this.play());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', () => this.play());
    document.addEventListener('visibilitychange', this.handleVisibility);

    if (this.slides.length > 1 && !this.reduceMotion.matches) this.play();
  }

  disconnectedCallback() {
    this.pause();
    document.removeEventListener('visibilitychange', this.handleVisibility);
  }

  handleVisibility = () => {
    if (document.hidden) this.pause();
    else this.play();
  };

  goTo(nextIndex) {
    if (!this.slides.length) return;
    this.index = (nextIndex + this.slides.length) % this.slides.length;
    this.slides[this.index].scrollIntoView({
      behavior: this.reduceMotion.matches ? 'auto' : 'smooth',
      block: 'nearest',
      inline: 'start',
    });
  }

  pause() {
    window.clearInterval(this.timer);
  }

  play() {
    this.pause();
    if (this.userPaused || this.reduceMotion.matches || document.hidden || this.slides.length < 2) return;
    this.timer = window.setInterval(() => this.goTo(this.index + 1), this.delay);
  }

  toggleAutoplay() {
    this.userPaused = !this.userPaused;
    this.toggleButton.setAttribute('aria-pressed', String(this.userPaused));
    this.toggleButton.textContent = this.userPaused ? 'Reproducir' : 'Pausar';
    this.userPaused ? this.pause() : this.play();
  }
}

if (!customElements.get('koketa-slider')) customElements.define('koketa-slider', KoketaSlider);
